<template>
  <div>
      <div class="row">
          <div class="col">
              <h4>Are you looking to Buy or Sell?</h4>
          </div>
      </div>
      <div class="row">
          <div class="col button-row">
              <b-button class="button yes-no" :class="[{'active': clientTypeQuestion === 'SELL'}]" pill variant="outline-secondary"
                        @click="updateClientTypeQuestion('sell')">SELL
              </b-button>
              <b-button class="button yes-no" :class="[{'active': clientTypeQuestion === 'BUY'}]" pill variant="outline-secondary"
                        @click="updateClientTypeQuestion('buy')">BUY
              </b-button>
          </div>
      </div>
  </div>
</template>

<script>
  import {saveField} from "@/services/apiService";

  export default {
      name: "ClientTypeQuestion",
      components: {},
      data() {
          return {
            clientTypeQuestion: undefined,
          }
      },
      methods: {
        updateClientTypeQuestion: function (value) {
              this.clientTypeQuestion = value;
              this.$emit('update-client-type', this.clientTypeQuestion);
              saveField('type', this.clientTypeQuestion);
              this.$emit('go-to-next-step');
          },    
          onError: function(text) {
              this.$emit('input', text);
          }
      }
  }
</script>

<style scoped>
  .button-row {
      padding: 5px;
  }

  .button {
      margin: auto;
      left: 0;
      right: 0;
      padding: 10px;
      width: 175px;
  }
  .yes-no{
      margin: 0 0 10px 10px;
  }
</style>
